<template>
  <el-card class="box-card full-screen">
    <div ref="pageHead" class="table-page-head">
      <el-form :inline="true" :model="queryForm">
        <el-form-item :label="$t('activityName')">
          <el-input v-model="queryForm.activityName" size="small"></el-input>
        </el-form-item>
        <el-form-item :label="$t('slipReference')">
          <el-input v-model="queryForm.slipReference" size="small"></el-input>
        </el-form-item>
        <el-form-item :label="$t('city')">
          <el-input v-model="queryForm.city" size="small"></el-input>
        </el-form-item>
        <el-form-item :label="$t('amount')">
          <el-input v-model="queryForm.amount" size="small"></el-input>
        </el-form-item>
        <el-form-item :label="$t('date')">
          <el-date-picker
            v-model="queryForm.date"
            type="daterange"
            range-separator="~"
            :start-placeholder="$t('startDate')"
            :end-placeholder="$t('endDate')"
            value-format="yyyy-MM-dd"
            size="small"
            unlink-panels
            :clearable="true"
            :picker-options="pickerOptions0"
            @change="changeDate"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            size="small"
            @click="getList"
            :loading="isLoading"
            ><i class="el-icon-search"></i> {{ $t("query") }}</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <div
      class="data-table"
      :style="{
        top: queryTableHeight,
        height: `calc(100% - ${queryTableHeight} - 70px)`
      }"
    >
      <el-table
        :data="tableData.records"
        v-loading="isLoading"
        element-loading-background="rgba(255,255,255,0.4)"
        size="mini"
        height="100%"
      >
        <el-table-column prop="id" fixed="left" :label="$t('ID')" width="70">
          <template slot-scope="scope">{{ scope.row.id }}</template>
        </el-table-column>

        <el-table-column
          prop="activityName"
          :label="$t('activityName')"
          width="250"
        ></el-table-column>
        <el-table-column prop="amount" :label="$t('amount')" width="160">
          <template slot-scope="scope">
            <span class="franc">₣</span>{{ scope.row.amount.formatMoney(0) }}
          </template>
        </el-table-column>
        <el-table-column prop="city" :label="$t('city')" width="160">
          <template slot-scope="scope">{{ scope.row.city }}</template>
        </el-table-column>
        <el-table-column prop="status" :label="$t('status')" width="160">
          <template slot-scope="scope">
            <span v-if="scope.row.status == 0" class="text-primary">{{
              $t("checkPending")
            }}</span>
            <span v-if="scope.row.status == 1" class="text-success">{{
              $t("completeTransaction")
            }}</span>
            <span v-if="scope.row.status == 2" class="text-danger">{{
              $t("notApproved")
            }}</span>
            <span v-if="scope.row.status == 3" class="text-warning">{{
              $t("completeReversal")
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="slipReference"
          :label="$t('slipReference')"
          width="160"
        >
          <template slot-scope="scope">{{ scope.row.slipReference }}</template>
        </el-table-column>
        <el-table-column prop="orgName" :label="$t('operateOrg')" width="160">
          <template slot-scope="scope"
            >{{ scope.row.orgName }} "("{{ scope.row.orgInfoCode }})"</template
          >
        </el-table-column>
        <el-table-column
          prop="partnerName"
          :label="$t('partnerName')"
          width="160"
        >
          <template slot-scope="scope">
            <div class="overstep-hidden">{{ scope.row.partnerName }}</div>
          </template>
        </el-table-column>

        <el-table-column
          prop="partnerAccount"
          :label="$t('partnerAccount')"
          width="160"
        >
          <template slot-scope="scope">
            <div class="overstep-hidden">{{ scope.row.partnerAccount }}</div>
          </template>
        </el-table-column>

        <el-table-column prop="partnerPhone" :label="$t('phone')" width="160">
          <template slot-scope="scope">
            <div class="overstep-hidden">{{ scope.row.partnerPhone }}</div>
          </template>
        </el-table-column>

        <el-table-column
          prop="createTime"
          :label="$t('creationTime')"
          width="200"
        >
          <template slot-scope="scope">{{
            $manba(scope.row.createTime).format("ymdhms")
          }}</template>
        </el-table-column>

        <el-table-column
          prop="verifyTime"
          :label="$t('verifyTime')"
          width="200"
        >
          <template slot-scope="scope">{{
            $manba(scope.row.verifyTime).format("ymdhms")
          }}</template>
        </el-table-column>

        <el-table-column prop="verifyRemark" :label="$t('remark')" width="220">
          <template slot-scope="scope">
            <div class="overstep-hidden">{{ scope.row.verifyRemark }}</div>
          </template>
        </el-table-column>
        <el-table-column fixed="right" :label="$t('extend')" width="210">
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.status == 0"
              type="primary"
              size="mini"
              @click="openCheckApply(scope.row)"
              >{{ $t("check") }}</el-button
            >
            <el-button v-else size="mini" disabled>{{ $t("check") }}</el-button>

            <el-button
              size="mini"
              v-if="scope.row.status == 0"
              @click="editBank(scope.row)"
              type="primary"
              >{{ $t("edit") }}</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      background
      layout="total,sizes,prev,pager,next,jumper"
      :total="tableData.total || 0"
      :page-sizes="[20, 30, 50, 100, 200]"
      :page-size="pageSize"
      :current-page="currentPage"
      @size-change="setPageSzie"
      @current-change="setCurrentChange"
      @prev-click="setCurrentChange"
      @next-click="setCurrentChange"
    />

    <el-drawer
      :title="$t('editAccount')"
      :visible.sync="editBankdrawer"
      :direction="'rtl'"
      :modal="false"
      :destroy-on-close="true"
      :wrapperClosable="false"
      :size="700"
    >
      <el-form :model="partnerForm" :rules="rules" ref="partnerForm">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item :label="$t('activityName')" prop="activityName">
              <el-input
                size="medium"
                v-model="partnerForm.activityName"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('city')" prop="city">
              <el-input
                size="medium"
                v-model="partnerForm.city"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item :label="$t('slipReference')" prop="slipReference">
              <el-input
                size="medium"
                v-model="partnerForm.slipReference"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('amount')" prop="amount">
              <el-input size="medium" v-model="partnerForm.amount"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item class="bottom-button">
          <el-button
            v-if="partnerForm.id"
            size="medium"
            type="primary"
            @click="updateSubmit('partnerForm')"
            :loading="isloading"
            >{{ $t("submit") }}</el-button
          >
          <!-- <el-button v-else size="medium" type="primary" @click="addSubmit('businessForm')" :loading="isloading">{{$t('submit')}}</el-button>
          -->
          <el-button
            v-else
            size="medium"
            type="primary"
            :loading="isLoading"
            @click="addSubmit('partnerForm')"
            >{{ $t("submit") }}</el-button
          >
        </el-form-item>
      </el-form>
    </el-drawer>

    <!-- 锁定/解锁账户弹框 -->

    <el-drawer
      :title="$t('remainingBalancePartnersCheck')"
      :visible.sync="partnerCheck.drawer"
      :direction="'rtl'"
      :modal="false"
      :destroy-on-close="true"
      :wrapperClosable="false"
      :size="700"
    >
      <el-form :model="partnerCheckForm" :rules="rules" ref="partnerCheckForm">
        <el-row :gutter="20">
          <el-form-item prop="id" style="display: none;">
            <el-input size="medium" v-model="partnerCheckForm.id" />
          </el-form-item>
          <el-col :span="12">
            <el-form-item :label="$t('partnerName')">
              <el-input
                v-model="partnerCheck.row.partnerName"
                size="small"
                disabled
              ></el-input>
            </el-form-item>

            <el-form-item :label="$t('partnerAccount')">
              <el-input
                v-model="partnerCheck.row.partnerAccount"
                size="small"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('phone')">
              <el-input
                v-model="partnerCheck.row.partnerPhone"
                size="small"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('activityName')">
              <el-input
                v-model="partnerCheck.row.activityName"
                size="small"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('slipReference')">
              <el-input
                v-model="partnerCheck.row.slipReference"
                size="small"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('date')">
              <el-input
                v-model="partnerCheck.row.createTime"
                size="small"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('amount')">
              <el-input
                v-model="partnerCheck.row.amount"
                size="small"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-divider content-position="left">{{ $t("checkInfo") }}</el-divider>
          <el-form-item :label="$t('checkStatus')" prop="status">
            <el-radio v-model="partnerCheckForm.status" :label="1" border>{{
              $t("getApproved")
            }}</el-radio>
            <el-radio v-model="partnerCheckForm.status" :label="2" border>{{
              $t("notApproved")
            }}</el-radio>
            <el-radio v-model="partnerCheckForm.status" :label="3" border>{{
              $t("cancel")
            }}</el-radio>
          </el-form-item>
          <el-form-item :label="$t('checkRemark')" prop="verifyRemark">
            <el-input
              type="textarea"
              size="medium"
              v-model="partnerCheckForm.verifyRemark"
            ></el-input>
          </el-form-item>
        </el-row>
        <div class="bottom-button">
          <el-button
            size="medium"
            type="primary"
            :loading="isLoading"
            @click="onSubmitCheckResult('partnerCheckForm')"
            >{{ $t("submit") }}</el-button
          >
        </div>
      </el-form>
    </el-drawer>
  </el-card>
</template>
<script>
import bank from "@/api/bank";

export default {
  name: "remainingBalancePartnersCheck",
  components: {},
  data() {
    return {
      queryForm: {},
      //table高度，动态设置
      queryTableHeight: String,
      //table显示内容
      tableData: {},
      //分页器默认参数
      pageSize: 20,
      currentPage: 1,
      //显示加载中
      isLoading: false,
      //右侧弹框
      editBankdrawer: false,
      partnerForm: { type: 1 },
      partnerCheckForm: {},

      printVisible: false,
      printParam: null,

      //addForm: { },
      partnerCheck: {
        drawer: false,
        form: {},
        row: {}
      },
      //禁用今天之后的日期选项
      pickerOptions0: {
        onPick: ({ maxDate, minDate }) => {
          this.minDate = minDate;
          this.maxDate = maxDate;
        },
        disabledDate: time => {
          let today = 3 * 30 * 24 * 3600 * 1000;
          if (this.minDate) {
            return (
              time.getTime() > Date.now() ||
              time > new Date(this.minDate.getTime() + today) ||
              time < new Date(this.minDate.getTime() - today)
            );
          }
          return time.getTime() > Date.now();
        }
      }
    };
  },
  computed: {
    rules() {
      return {
        status: [
          {
            required: true,
            message: this.$t("requiredFields"),
            trigger: "blur"
          }
        ]
      };
    },
    //imgError () { return this.$store.state.system.imgError; },

    loginInfo() {
      return this.$store.state.globalParameter.loginInfo;
    }
  },
  watch: {
    "queryForm.date"(newVal) {
      if (newVal && newVal.length > 0) {
        this.queryForm.startTime = this.queryForm.date[0];
        this.queryForm.endTime = this.queryForm.date[1];
      } else {
        this.queryForm.startTime = undefined;
        this.queryForm.endTime = undefined;
      }
    }
  },
  methods: {
    /**查询列表 */
    getList() {
      let _this = this;
      let params = JSON.parse(JSON.stringify(_this.queryForm));
      if (params.date && params.date.length > 0) {
        params.startTime = _this.$manba(params.date[0]).format("ymd");
        params.endTime = _this.$manba(params.date[1]).format("ymd");
      } else {
        params.startTime = undefined;
        params.endTime = undefined;
      }
      delete params.date;
      bank.getPartnerRemainingBalancePage({
        param: {
          current: _this.currentPage,
          size: _this.pageSize,
          ..._this.queryForm
        },
        success: res => {
          _this.tableData = res.data || {};
          _this.isLoading = false;
        }
      });
    },
    changeDate(e) {
      if (e === null) {
        this.minDate = "";
        this.maxDate = "";
        this.pickerBeginDateBefore = {
          disabledDate: time => {
            let three = 3 * 30 * 24 * 3600 * 1000;
            if (this.minDate) {
              return (
                time.getTime() > Date.now() ||
                time > new Date(this.minDate.getTime() + three) ||
                time < new Date(this.minDate.getTime() - three)
              );
            }
            return time.getTime() > Date.now();
          }
        };
      }
    },

    setPageSzie(val) {
      this.pageSize = val;
      this.getList();
    },
    setCurrentChange(val) {
      this.currentPage = val;
      this.getList();
    },
    /**格式化地区 */

    openCheckApply(row) {
      this.partnerCheck.row = row;
      this.partnerCheckForm = {
        phone: row.partnerPhone,
        amount: row.amount,
        status: status,
        id: row.id,
        partnerAccount: row.partnerAccount,
        transferCode: row.transferCode
      };
      this.partnerCheck.drawer = true;
    },
    editBank(data) {
      let _this = this;

      _this.partnerForm = { type: 0 };
      if (data) _this.partnerForm = data;
      _this.editBankdrawer = true;
    },

    updateSubmit(formName) {
      let _this = this;
      _this.$refs[formName].validate(valid => {
        if (valid) {
          _this.isloading = true;
          bank.updateRemainingBalancePartners({
            param: _this[formName],
            success: res => {
              if (res.code == 200) {
                _this.$message({
                  type: "success",
                  message: _this.$t("operateSuccessfully")
                });
                _this.getList();
                _this.editBankdrawer = false;
              } else {
                _this.$message({ type: "warning", message: _this.$t(res.msg) });
              }
              _this.isloading = false;
            }
          });
        }
      });
    },

    onSubmitCheckResult(refName) {
      let _this = this;
      _this.$refs[refName].validate(valid => {
        if (!valid) return false;
        bank.updateRemainingBalancePartnersStatus({
          param: _this.partnerCheckForm,
          success: res => {
            if (res.code == 200) {
              _this.getList();
              _this.partnerCheck.drawer = false;
              _this.$message.success(_this.$t("operateSuccessfully"));
            } else _this.$message.warning(this.$t(res.msg));
          }
        });
      });
    }
  },
  created() {},
  mounted() {
    let queryTableHeight = this.$refs.pageHead.offsetHeight + 15;
    this.queryTableHeight = queryTableHeight + "px";
    this.getList();
  }
};
</script>

<style lang="less" scoped></style>
